<template>
    <div>callback</div>
</template>

<script>
    import { consumePostLoginRoute, defaultRouteName } from "../navigation";

    export default {
        name: 'Callback',
        props: [],
        components: {},
        data: function() {
            return	{
            }
        },


        created(){
        },

        watch:{
        },

        computed:{
        },

        mounted(){
            this.$auth.handleAuthentication().then(() => {
                const requestedRoute = consumePostLoginRoute();
                this.$router.replace(requestedRoute || { name: defaultRouteName() });
            });      
        },

        methods:{
        },
    }
</script>

<style scoped>

</style>
